import React, { useEffect, useState } from 'react';
import axios, { AxiosError, AxiosResponse } from 'axios';
import ExitToApp from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import { createStyles, makeStyles, StyleRules, Theme } from '@material-ui/core/styles';
import { AppBar, Container, IconButton, MenuItem, MenuList, Toolbar } from '@material-ui/core';
import Link from 'next/link';
import { withRouter } from 'next/router';
import dynamic from 'next/dynamic';
import styles from './Header.module.css';
import { useAuth } from '../../lib/useAuth';
import { Button } from '../formikFormInputs';
import { Agreement, LoginDialog } from '../AgentResources/Login';
import TelContact from './TelContact';
import { externalServerUrl } from '../../server/constants';
import logo from '../../public/images/niw-logo.png';
import esdLogo from '../../public/images/esdLogo.jpg';
import trizenLogo from '../../public/images/trizenLogo.jpg';
import kaizenLogo from '../../public/images/kaizenLogo.jpg';
import { ADMIN_ROLES, AGENT_SIGNING_KEY, initFalse, MENUOPTIONS } from '../../utils/constants';
import { checkErrorStatusCode, checkSellerAgreementSignValid, errorLog } from '../../utils/commonUtils';
import { LoginType, Paths, ROLES } from '../../utils/enums';

const StrategyForYouDrawer = dynamic(() => import('./StrategyForYouDrawer'));
const AboutNiwDrawer = dynamic(() => import('./AboutNiwDrawer'));
const MobileDrawer = dynamic(() => import('./MobileDrawer'));

export const headerStyles: (theme: Theme, conditionalLoad?: boolean) => StyleRules = (theme, conditionalLoad) => {
  return {
    grow: {
      flexGrow: 1,
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    sectionDesktop: {
      display: 'none',
      [ theme.breakpoints.up('lg') ]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      float: 'left',
      // left: -25,
      position: 'relative',
      // width: 30,
      [ theme.breakpoints.up('lg') ]: {
        display: 'none',
      },
      [ theme.breakpoints.down('md') ]: {
        // left: '-29px',
        display: 'flex',
      },
      [ theme.breakpoints.down('sm') ]: {
        // left: '-25px !important',
        // width: 15,
      },
    },
    MobileMenuOption: {
      float: 'left',
      [ theme.breakpoints.down('md') ]: {
        marginRight: 10,
      },
      [ theme.breakpoints.down(768) ]: {
        top: 0,
        marginRight: 0,
      },

    },
    logoLink: {
      float: 'left',
      position: 'relative',
      lineHeight: '0'
    },
    logo: {
      cursor: 'pointer',
      margin: '0px 50px 0 10px',

      [ theme.breakpoints.down('md') ]: {
        margin: '20px 0 15px 0',
        width: 100,
        height: 25,
      },
    },
    logoStrategy: {
      maxHeight: 35,
      margin: 15,
      cursor: 'pointer',
    },
    floatRight: {
      float: 'right',
    },
    topHeader: {
      background: '#203053',
      color: '#ffffff',
      float: 'left',
      width: '100%',
      position: 'fixed',
      top: 0,
      zIndex: 1400,
    },
    topHeaderItem: {
      float: 'right',
      a: {
        color: '#FFFFFF !important',
      },
      [ theme.breakpoints.down('sm') ]: {
        padding: '10px 10px !important'
      },
      [ theme.breakpoints.down(767) ]: {
        fontSize: '13px !important',
      },
    },
    topHeaderItemLink: {
      color: '#ffffff',
      display:'flex',
      alignItems:'center'
    },
    displayFlex: conditionalLoad ? {
      display: 'flex'
    } : {
      display: 'flex-2'
    },
    marginBottomIlia: {
      marginTop: '-5px'
    }
  };
};
const useStyles = makeStyles((theme: Theme) => createStyles(headerStyles(theme)), {name: 'MuiCustomHeaderStyle'});

function PrimarySearchAppBar(props: { router: any, resetFindYourStrategy?: Function, emptyFindStrategyName?: Function, scollTop?: Function }) {
  const classes = useStyles();
  const {router, resetFindYourStrategy, emptyFindStrategyName, scollTop} = props;
  const [showConfirmation, setShowConfirmation] = React.useState(initFalse);
  const [isTop, setIsTop] = useState(!initFalse);
  const [isInvitePage, setInvitePage] = useState(initFalse);
  const [mobileAccordion, setMobileAccordion] = useState(initFalse);
  const [selectMenu, setSelectedMenu] = useState(0);
  const [openStrategyDrawer, setOpenStrategyDrawer] = useState(initFalse);
  const [openAboutNIWDrawer, setOpenAboutNIWDrawer] = useState(initFalse);
  const [showLogout, setShowLogout] = useState(initFalse);
  const [isKaizenLeadPage, setKaizenLeadPage] = useState(initFalse);
  const [menuContent, setMenuContent] = useState(undefined);
  const [isLoggingOut, setIsLoggingOut] = useState(initFalse);
  const {user, logout} = useAuth();
  const onCancel = async () => {
    await logout()
    setShowConfirmation(initFalse);
  };
  const onConfirm = async () => {
    setShowConfirmation(initFalse);
    return router.push(Paths.AgentPortal);
  };

  const handleScroll = () => {
    const isTop = window.scrollY < 100;
    setIsTop(isTop);
  };

  const getMenuContent = async () => {
    const res = await fetch(`${externalServerUrl}/api/menu/menu`);
    const page: any = await res.json();
    setMenuContent(page);
  };

  useEffect(() => {
    getMenuContent().then(() => {
    })
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isTop]);

  useEffect(() => {
    const pathName = router.pathname.toLowerCase();
    if (pathName.includes('estate-planning') ||
      pathName.includes('retirement-planning') ||
      pathName.includes('business-planning')) {
      setSelectedMenu(MENUOPTIONS.STRATEGYFORYOU);
    } else if (pathName.includes('myilia')) {
      setSelectedMenu(MENUOPTIONS.STRATEGYMANAGEMENT);
    } else if (pathName.includes('about-niw') ||
      pathName.includes('contact')) {
      setSelectedMenu(MENUOPTIONS.ABOUT_NIW)
    } else if (pathName.includes('agent-locator')) {
      setSelectedMenu(MENUOPTIONS.AGENT_LOCATOR)
    } else if (pathName.includes('for-agent')) {
      setSelectedMenu(MENUOPTIONS.FORAGENT);
    } else if (pathName.includes('agent-resources')) {
      setSelectedMenu(MENUOPTIONS.FORAGENT);
    }
    if (pathName.includes('kai-zen-strategy') ||
      pathName.includes('tri-zen-strategy') ||
      pathName.includes('esd')) {
      setInvitePage(true)
    }
    if (pathName.includes('retirement-planning/kai-zen')) {
      setKaizenLeadPage(false);
    }
  }, []);

  useEffect(() => {
    setShowLogout(!!user);
  }, [user]);

  useEffect(() => {
    axios.interceptors.response
      .use((response: AxiosResponse) => {
        return response;
      }, (error: AxiosError) => {
        if (checkErrorStatusCode(error)) {
          errorLog(error);
          logout();
        }
        return Promise.reject(error);
      });
  }, []);

  const handleMobileMenuOption = () => {
    setMobileAccordion(!mobileAccordion)
  };

  const handleFindYourStrategy = () => {
    closeDrawer();
    router.push('/find-niw-strategy');
    if (typeof resetFindYourStrategy === 'function') {
      resetFindYourStrategy({
        type: 'reset', value: ''
      });
    }
    if (typeof emptyFindStrategyName === 'function') {
      emptyFindStrategyName('');
    }
  };

  const handleLogout = async (event: any) => {
    event.preventDefault();
    setIsLoggingOut(!initFalse);
    try {
      await logout();
      setShowLogout(initFalse);
      // @ts-ignore TS1196: Catch clause variable cannot have a type annotation.
    } catch (err: any) {
      errorLog(err);
    } finally {
      setIsLoggingOut(initFalse);
    }
  };

  const handleHome = () => {
    closeDrawer();
    setSelectedMenu(0);
    setTimeout(() => {
      const pathName = router.pathname.toLowerCase();
      if (pathName !== '/') {
        router.push('/');
      } else if (scollTop) {
        scollTop();
      }
    }, 500);
  };

  const closeDrawer = () => {
    setOpenStrategyDrawer(false);
    setOpenAboutNIWDrawer(false);
  };

  const onAgentAction = () => {
    return user && user.role === ROLES.Agent ? router.push(Paths.AgentPortal) : setLoginType(LoginType.Agent);
  };

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <MobileDrawer
      mobileAccordion={mobileAccordion}
      setMobileAccordion={setMobileAccordion}
      setOpenStrategyDrawer={setOpenStrategyDrawer}
      menuContent={menuContent}
      refreshMenu={getMenuContent}
    />
  );
  const pathName = router.pathname.toLowerCase();
  const [loginType, setLoginType] = useState<string>('');

  const agent_agreement_signing = localStorage.getItem(AGENT_SIGNING_KEY);
  useEffect(() => {
    if (agent_agreement_signing && router.isReady) {
      setShowConfirmation(!initFalse)
    }
  }, [agent_agreement_signing]);


  return (
    <>
      {
        showConfirmation && user && !checkSellerAgreementSignValid(user.agent.sellerAgreements) &&
        <Agreement onCancel={onCancel} onConfirm={onConfirm} show={showConfirmation}/>
      }
      {
        !isKaizenLeadPage &&
        <div className={classes.topHeader + ' ' + classes.floatRight}>
          <Container maxWidth="lg">
            <MenuList style={{padding: 0, float: 'left', width: '100%'}}>
              {
                showLogout &&
                <MenuItem className={classes.topHeaderItem}>
                  <a className={classes.topHeaderItemLink} onClick={handleLogout} >
                    {isLoggingOut ? 'Logging out...' : 'Logout'}  <ExitToApp className="textWhite ml5" onClick={handleLogout}/>
                  </a>
                </MenuItem>
              }
              {
                !user &&
                // TODO Client Login button hidden from view
                <MenuItem className={classes.topHeaderItem} style={{display: 'none'}}>
                  <a href="#" className={classes.topHeaderItemLink} onClick={() => setLoginType(LoginType.Client)}>
                    Client Login
                  </a>
                </MenuItem>
              }
              {
                ((user && user.role === ROLES.Agent) || !user) &&
                <MenuItem className={classes.topHeaderItem}>
                  <a href="#" className={classes.topHeaderItemLink} onClick={onAgentAction}>
                    {
                      user ? (user.role === ROLES.Agent && 'Go to my portal') : 'Agent Login'
                    }
                  </a>
                </MenuItem>
              }
              {
                (user && ADMIN_ROLES.includes(user.role)) &&
                <MenuItem className={classes.topHeaderItem}>
                  <a href="#" className={classes.topHeaderItemLink}>
                    Admin Logged
                  </a>
                </MenuItem>
              }
              <MenuItem className={classes.topHeaderItem}>
                <a
                  href="#" onClick={() => {
                  closeDrawer();
                  router.push('/contact')
                }} className={classes.topHeaderItemLink}
                >
                  Contact us
                </a>
              </MenuItem>
              <TelContact topHeaderItem={classes.topHeaderItem} topHeaderItemLink={classes.topHeaderItemLink}/>
            </MenuList>
          </Container>
        </div>
      }
      <div className={classes.grow}>
        <AppBar
          position="fixed"
          className={`show ${isKaizenLeadPage ? 'iliaLogo' : ''} ${styles.header}`}
          style={{background: '#FFFFFF'}}
        >
          <Container maxWidth="lg">
            <Toolbar className="pd0">
              <div className={classes.displayFlex}>
                <div className={classes.sectionMobile}>
                  {
                    !isInvitePage &&
                    <IconButton
                      className={classes.MobileMenuOption}
                      aria-label="show more"
                      aria-controls={mobileMenuId}
                      aria-haspopup="true"
                      onClick={handleMobileMenuOption}
                      color="primary"
                    >
                      <MenuIcon/>
                    </IconButton>
                  }
                </div>
                <a
                  href="#" onClick={handleHome} className={classes.logoLink}
                >
                  <img width="150px" height="50px" src={logo} className={classes.logo} alt="logo"/>
                </a>
                {
                  isInvitePage &&
                  <>
                    {
                      pathName.includes('esd') &&
                      <Link href="/">
                        <a><img src={esdLogo} className={classes.logoStrategy} alt="esd logo"/></a>
                      </Link>
                    }
                    {
                      pathName.includes('trizen') &&
                      <Link href="/">
                        <a><img src={trizenLogo} className={classes.logoStrategy} alt="trizen logo"/></a>
                      </Link>
                    }
                    {
                      pathName.includes('kaizen') &&
                      <Link href="/">
                        <a><img src={kaizenLogo} className={classes.logoStrategy} alt="kaizen logo"/></a>
                      </Link>
                    }
                  </>
                }
              </div>
              <div className={classes.sectionDesktop}>
                {
                  !isInvitePage &&
                  <>
                    <Button
                      onClick={() => {
                        setOpenStrategyDrawer(!openStrategyDrawer);
                        setSelectedMenu(MENUOPTIONS.STRATEGYFORYOU);
                        setOpenAboutNIWDrawer(false);
                      }}
                      className={(openStrategyDrawer || selectMenu === MENUOPTIONS.STRATEGYFORYOU) ? styles.active + " menuButton " : ' menuButton '}>
                      <Link href="#">
                        Our Offerings
                      </Link>
                    </Button>
                    {
                      <StrategyForYouDrawer
                        openStrategyDrawer={openStrategyDrawer}
                        setOpenStrategyDrawer={setOpenStrategyDrawer}
                        menuContent={menuContent}
                        refreshMenu={getMenuContent}
                      />
                    }
                    <Button
                      onClick={() => {
                        setSelectedMenu(MENUOPTIONS.FORAGENT);
                        setOpenStrategyDrawer(false);
                        setOpenAboutNIWDrawer(false);
                        router.push("/agent-resources")
                      }}
                      className={(selectMenu === MENUOPTIONS.FORAGENT) ? styles.active + " menuButton " : ' menuButton '}
                    >
                      <Link href="/agent-resources">
                        For Agents
                      </Link>
                    </Button>
                    <Button
                      onClick={() => {
                        setOpenStrategyDrawer(false);
                        setSelectedMenu(MENUOPTIONS.STRATEGYMANAGEMENT);
                        setOpenAboutNIWDrawer(false);
                        router.push("/myilia")
                      }}
                      className={(selectMenu === MENUOPTIONS.STRATEGYMANAGEMENT) ? styles.active + " menuButton " : ' menuButton '}
                    >
                      <Link href="/myilia">
                        About ilia&reg;
                      </Link>
                    </Button>
                    <Button
                      onClick={() => {
                        setOpenAboutNIWDrawer(!openAboutNIWDrawer);
                        setSelectedMenu(MENUOPTIONS.ABOUT_NIW);
                        setOpenStrategyDrawer(false);
                      }}
                      className={(openAboutNIWDrawer || selectMenu === MENUOPTIONS.ABOUT_NIW) ? styles.active + " menuButton " : ' menuButton '}
                    >
                      <Link href="#">
                        About NIW
                      </Link>
                    </Button>
                    {
                      <AboutNiwDrawer openAboutNIWDrawer={openAboutNIWDrawer}
                                      setOpenAboutNIWDrawer={setOpenAboutNIWDrawer}/>
                    }
                    <Button
                      onClick={() => {
                        setOpenStrategyDrawer(false);
                        setSelectedMenu(MENUOPTIONS.AGENT_LOCATOR);
                        setOpenAboutNIWDrawer(false);
                        router.push("/agent-locator")
                      }}
                      className={(selectMenu === MENUOPTIONS.AGENT_LOCATOR) ? styles.active + " menuButton " : ' menuButton '}
                    >
                      <Link href="/agent-locator">
                        Agent Locator
                      </Link>
                    </Button>
                    <Button
                      className={'menuButton'}
                    >
                      <span className="MuiButton-label">
                        <a href="https://locktonaffinitylifeagent.com/" target="_blank">
                          E&O Insurance
                        </a>
                      </span>
                    </Button>
                  </>
                }
              </div>
              <div className={classes.grow}/>
              <div className={classes.floatRight + ' ' + ' forRealButton '}>
                {
                  !isInvitePage &&
                  <Button
                    onClick={handleFindYourStrategy} variant="contained" size="small" color="primary"
                  >Find Your Strategy</Button>
                }
              </div>
            </Toolbar>
          </Container>
          <LoginDialog userType={loginType} isOpen={!!loginType} close={() => setLoginType('')}/>
        </AppBar>
      </div>
      {
        renderMobileMenu
      }
    </>
  );
}

export default withRouter(PrimarySearchAppBar)
